/** Registre aide contextuelle Karaté Phase 1 — BT-028-R1 FR/EN. */
import { helpTopicsFr } from "@/content/helpTopics.fr.js";
import { helpTopicsEn } from "@/content/helpTopics.en.js";
import { helpTopicsAdminFr028R1, helpFallbackFr028R1 } from "@/content/helpTopicsAdmin028R1.fr.js";
import { helpTopicsAdminEn028R1, helpFallbackEn028R1 } from "@/content/helpTopicsAdmin028R1.en.js";
import { helpTopicsAdminFr028R2 } from "@/content/helpTopicsAdmin028R2.fr.js";
import { helpTopicsAdminEn028R2 } from "@/content/helpTopicsAdmin028R2.en.js";
import { helpTopicsLaunchCockpitFr } from "@/content/helpTopicsLaunchCockpit.fr.js";
import { helpTopicsLaunchCockpitEn } from "@/content/helpTopicsLaunchCockpit.en.js";
import { helpTopicsMembershipFr } from "@/content/helpTopicsMembership001.fr.js";
import { helpTopicsMembershipEn } from "@/content/helpTopicsMembership001.en.js";
import { attachFormationHelpLinks } from "@/content/helpTopicsFormation001.js";

const mergedFr = attachFormationHelpLinks(
  { ...helpTopicsFr, ...helpTopicsAdminFr028R1, ...helpTopicsAdminFr028R2, ...helpTopicsLaunchCockpitFr, ...helpTopicsMembershipFr },
  "fr",
);
const mergedEn = attachFormationHelpLinks(
  { ...helpTopicsEn, ...helpTopicsAdminEn028R1, ...helpTopicsAdminEn028R2, ...helpTopicsLaunchCockpitEn, ...helpTopicsMembershipEn },
  "en",
);

/** @param {'fr'|'en'} locale */
export function getHelpTopicRegistry(locale = "fr") {
  return locale === "en" ? mergedEn : mergedFr;
}

/** @param {'fr'|'en'} locale */
export function getHelpFallbackTopic(locale = "fr") {
  return locale === "en" ? helpFallbackEn028R1 : helpFallbackFr028R1;
}

/** @deprecated use getHelpTopicRegistry(locale) */
export const helpTopicRegistry = mergedFr;

/** @deprecated use getHelpFallbackTopic(locale) */
export const helpFallbackTopic = helpFallbackFr028R1;
